import React from 'react';
import PropTypes from 'prop-types';

const AtivosRow = (props) => {
    return (
        <tr>
            <td>{props.ativo.nome}</td>
            <td>
                <i className="far fa-edit" style={{ cursor: "pointer" }}
                    onClick={() => props.handleUpdate(props.ativo)} />
                {" | "}
                <i className="far fa-trash-alt" style={{ cursor: "pointer" }}
                    onClick={() => props.handleDelete(props.ativo.id)} />
            </td>
        </tr>
    );
};

AtivosRow.propTypes = {
    ativo: PropTypes.object.isRequired,
    handleDelete: PropTypes.func.isRequired,
    handleUpdate: PropTypes.func.isRequired,
};

export default AtivosRow;


// WEBPACK FOOTER //
// ./src/components/ativos/AtivosRow.js